import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBookingValue } from "../../../core/redux/action";
import apiHandler from "../../common/api";
import Select from "react-select";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import DatePickup from "../DatePickup/DatePickup";
// import close_circle from "../../../core/img/close-icon.svg";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import config from "../../../config";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
// import { Trash2 } from "feather-icons-react/build/IconComponents";
import axios from "axios";

const AddStaffappointment = ({
  resourceData,
  businessHours,
  viewtype,
  callbackHandelCancle,
}) => {
  const userData = useSelector((state) => state.user_data);
  const BookingValue = useSelector((state) => state.BookingValue);

  console.log(BookingValue, "BOOKINGVASLUE");

  const [times, settimes] = useState([]);
  const [avilableTimes, seAvilableTimes] = useState([]);
  const [startTime, setstartTime] = useState(
    moment(resourceData?.start).format("HH:mm")
  );
  let [endTime, setendTime] = useState(
    moment(resourceData?.end).format("HH:mm")
  );

  const selectDate = moment(resourceData?.start).format("dd/MM/yyyy");
  let [today, settoday] = useState(moment(resourceData?.start).format("dddd"));

  const [Date, setDate] = useState(selectDate);
  console.log(avilableTimes, " avilableTimes 132");
  console.log(Date, " Date 132");

  const dispatch = useDispatch();
  const [customeroption, setcustomeroption] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [bookingview, setbookingview] = useState(false);
  const [monthlayout, setmonthlayout] = useState(false);
  const [serivesTeam, setserviceTeam] = useState({});
  const [serviceData, setservicedata] = useState([]);
  const [TeamData, setTeamData] = useState([]);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen2, setIsOpen2] = useState(true);
  const [NonTeamData, setnTeamData] = useState([]);
  const [Teamservicecommission, setTeamservicecommission] = useState([]);
  const [Teamdataget, setTeamdataget] = useState(false);
  const [serviceFilter, setServiceFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [genderOptions, setGenderOptions] = useState([]);
  // const [perSe setPerServiceProfessional] = useState(true);
  const [selectPerService, setSelectPerService] = useState(false);
  const [showAnyProfessionAgain, setShowAnyProfessionAgain] = useState(false);
  const [isDeskTopScreen, setisDeskTopScreen] = useState(false);
  const [isSmollScreen, setisSmollScreen] = useState(false);

  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [tab3, setTab3] = useState(false);
  const [tab4, setTab4] = useState(false);

  console.log(serivesTeam, showAnyProfessionAgain, "TeamDataTeamData");
  console.log(loading, "loading23132132132");
  console.log(
    isSmollScreen,
    isDeskTopScreen,
    isOpen2,
    isOpen1,
    isOpen,
    setIsOpen2,
    setIsOpen1,
    setIsOpen,
    setisSmollScreen,
    setisDeskTopScreen,
    "TeamDataTeamData"
  );

  useEffect(() => {
    const handleResize = () => {
      setisSmollScreen(window.innerWidth < 1000);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setisDeskTopScreen(window.innerWidth < 1450);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  console.log(serviceData, "serviceData");

  console.log(isDeskTopScreen, "isDeskTopScreen 1212121");

  console.log(TeamData, "TeamData 1321321321321");

  const handleCancel = () => callbackHandelCancle();

  const Handlechange = (e) => {
    const { label, email, value } = e;

    let BookingValues = {
      SelectedCustomer: value,
      ID: 0,
      formvalue: {
        FirstName: "",
        LastName: "",
        MobileNumber: "",
        Email: "",
        Date: "",
        ID: 0,
        Gender: 1,
      },
      GroupCustomers: [
        {
          label,
          value,
          email,
          checked: true,
          PlaceValue: 1,
        },
      ],

      ServiceData: [],
      IndiviualCustomer: true,
      GroupCustomer: false,
    };

    dispatch(setBookingValue(BookingValues));
    setbookingview(false);
    setTeamdataget(!Teamdataget);
  };

  const swiperGroupAnimate = {
    modules: [Autoplay, Pagination, Navigation],
    spaceBetween: 24,
    slidesPerView: "auto",
    slidesPerGroup: 1,
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next-animate",
      prevEl: ".swiper-button-prev-animate",
    },
    autoplay: {
      delay: 10000,
    },
    breakpoints: {
      1199: {
        slidesPerView: "auto",
      },
      600: {
        slidesPerView: "auto",
      },
      575: {
        slidesPerView: 1,
      },
      350: {
        slidesPerView: 1,
      },
    },
  };

  const dates = businessHours;

  console.log(businessHours, "jhdhhdhhk", Date);

  const HandleGuest = () => {
    const groupCustomers = BookingValue?.GroupCustomers || [];

    const newGuest = {
      label: `Guest ${groupCustomers.length + 1}`,
      value: 0,
      email: "",
      checked: false,
      PlaceValue: groupCustomers.length + 1,
    };

    dispatch(
      setBookingValue({
        ...BookingValue,
        GroupCustomers: [...groupCustomers, newGuest],
      })
    );
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const oppositeName =
      name === "IndiviualCustomer" ? "GroupCustomer" : "IndiviualCustomer";

    dispatch(
      setBookingValue({
        ...BookingValue,
        [name]: checked,
        [oppositeName]: !checked,
      })
    );
  };
  const Handlegroupcheck = (e, index) => {
    const { checked } = e.target;

    const updatedGroupCustomers = BookingValue?.GroupCustomers?.map(
      (item, i) => ({
        ...item,
        checked: i === index ? checked : false,
      })
    );

    dispatch(
      setBookingValue({
        ...BookingValue,
        GroupCustomers: updatedGroupCustomers,
      })
    );
  };

  const handlesubmitdata = async () => {
    if (
      BookingValue?.formvalue?.ID == 0 &&
      BookingValue?.SelectedCustomer == -1
    ) {
      if (
        BookingValue?.formvalue?.FirstName == "" ||
        BookingValue?.formvalue?.Email == ""
      ) {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Add required field",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      const responseb = await apiHandler({
        method: "POST",
        route: "Business/walkincustomerUpsert",
        payload: {
          ID: 0,
          firstname: BookingValue?.formvalue?.FirstName,
          Lastname: BookingValue?.formvalue?.LastName,
          email: BookingValue?.formvalue?.Email,
          birthDate: BookingValue?.formvalue?.Date,
          phoneNumber: BookingValue?.formvalue?.MobileNumber,
          gender: BookingValue?.formvalue?.Gender,
          businessId: userData?.businessId,
        },
      });

      console.log(responseb, "walkincustomerUpsert");

      // Swal.fire({
      //     position: "top-end",
      //     icon: "success",
      //     title:"Customer Added!",
      //     text: "The Customer has been successfully added.",
      //     showConfirmButton: false,
      //     timer: 1500,
      //   });
      setTab1(false);
      setTab2(true);

      dispatch(
        setBookingValue({
          ...BookingValue,
          formvalue: BookingValue?.formvalue,
          SelectedCustomer: responseb?.ResponseID,
        })
      );
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Customer Already exsit with same Email",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const handleclear = (index, label) => {
    const updatedGroupCustomers = BookingValue?.GroupCustomers?.filter(
      (el, i) => i != index
    );
    const updateservice = BookingValue?.ServiceData?.filter(
      (el) => el.customerlabel != label
    );

    dispatch(
      setBookingValue({
        ...BookingValue,
        GroupCustomers: updatedGroupCustomers,
        ServiceData: updateservice,
      })
    );
  };
  const handleFormValue = (e) => {
    const { name, value } = e.target;
    dispatch(
      setBookingValue({
        ...BookingValue,
        formvalue: { ...BookingValue?.formvalue, [name]: value },
      })
    );
  };


  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    // Ensure it starts with +61
    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    // Remove + for formatting spaces, but keep for final output
    const noPlus = cleaned.replace("+", "");

    // Format: +61 4 1234 5678
    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  const isValidAustralianPhoneNumbercust = (number) => {
    const digits = number.replace(/\D/g, ""); // remove non-digits
    const mobilePattern = /^61[4]\d{8}$/; // Mobile
    const landlinePattern = /^61[2378]\d{8}$/; // Landline
    const testPattern = /^61[5]\d{8}$/; // If you also want 5xx (test case you gave)

    return (
      mobilePattern.test(digits) ||
      landlinePattern.test(digits) ||
      testPattern.test(digits)
    );
  };

  const handleInputChange = (date) => {
    dispatch(
      setBookingValue({
        ...BookingValue,
        formvalue: {
          ...BookingValue?.formvalue,
          ["Date"]: moment(date).format("YYYY-MM-DD"),
        },
      })
    );
  };

  const Handleservices = (el) => {

    console.log(el, "check this serviceDuration 4545454545454554");

    const customer = BookingValue?.GroupCustomers?.find((item) => item.checked);

    if (!customer) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `Select customer before add service`,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    if (
      BookingValue?.ServiceData?.some(
        (els) =>
          els.serviceVariationId === el.PriceID &&
          els.customerlabel == customer.label
      )
    ) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `You have already added this service with the same customer`,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    const newEntry = {
      PlaceValue: customer.PlaceValue,
      customerlabel: customer.label,
      ID: el?.serviceId,
      serviceVariationId: el?.PriceID,
      serviceName: el?.name,
      servicePrice: el?.price,
      menucategory: el.category,
      imageUrl: el.imageUrl,
      serviceDuration: el?.maxduration,
      AppointmentdetileID: 0,
      Teamname: "Any professional",
      TeamId: 0,
      Comission: "0",
      homeServicePrice: "0",
    };

    dispatch(
      setBookingValue({
        ...BookingValue,
        ServiceData: [...(BookingValue?.ServiceData || []), newEntry],
      })
    );
  };

  const handleAddTeam = (item) => {
    setserviceTeam(item);
    setShowModal(true);
  };

  const Handleremoveservices = (el) => {
    let updatedata = BookingValue?.ServiceData?.filter(
      (els) =>
        !(
          els.serviceVariationId == el.serviceVariationId &&
          els.PlaceValue == el.PlaceValue
        )
    );
    setTeamdataget(!Teamdataget);
    dispatch(
      setBookingValue({
        ...BookingValue,
        ServiceData: updatedata,
      })
    );
  };

  // const handleaddteamtoservice = (
  //   serviceVariationId,
  //   PlaceValue,
  //   serviceId,
  //   id,
  //   fullName,
  //   image
  // ) => {
  //   let commisiiondata = Teamservicecommission.find(
  //     (el) => el?.staffId == id && el?.serviceId == serviceId
  //   );

  //   const updatedGroupCustomers = BookingValue?.ServiceData?.map((item) => ({
  //     ...item,
  //     Teamname:
  //       item?.serviceVariationId === serviceVariationId &&
  //       item?.PlaceValue === PlaceValue
  //         ? fullName
  //         : item?.Teamname,
  //     TeamId:
  //       item?.serviceVariationId === serviceVariationId &&
  //       item?.PlaceValue === PlaceValue
  //         ? id
  //         : item?.TeamId,
  //     Comission:
  //       item?.serviceVariationId === serviceVariationId &&
  //       item?.PlaceValue === PlaceValue
  //         ? commisiiondata?.staffCommision || 0
  //         : item?.Comission,
  //     homeServicePrice:
  //       item?.serviceVariationId === serviceVariationId &&
  //       item?.PlaceValue === PlaceValue
  //         ? commisiiondata?.homeServicePrice || 0
  //         : item?.homeServicePrice,
  //     teamimg:
  //       item?.serviceVariationId == serviceVariationId &&
  //       item?.PlaceValue == PlaceValue
  //         ? image
  //         : item?.teamimg,
  //   }));

  //   const updatedBookingValue = {
  //     ...BookingValue,
  //     ServiceData: updatedGroupCustomers,
  //   };

  //   dispatch(setBookingValue(updatedBookingValue));
  //   setbookingview(false);

  //   if (id >= 0) {
  //     let teamvalue = NonTeamData;

  //     for (let i = 0; i < updatedBookingValue.ServiceData.length; i++) {
  //       const teamId = updatedBookingValue.ServiceData[i]?.TeamId;
  //       if (teamId && teamId !== 0) {
  //         teamvalue = teamvalue.filter((el) => el.id !== teamId);
  //       }
  //     }

  //     setTeamData(teamvalue);
  //   }

  //   setShowModal(false);
  // };

  const handleaddteamtoservice = (
    serviceVariationId,
    PlaceValue,
    serviceId,
    id,
    fullName,
    image
  ) => {
    let commissionData = Teamservicecommission.find(
      (el) => el?.staffId === id && el?.serviceId === serviceId
    );

    let updatedGroupCustomers;
    if (selectPerService) {
      updatedGroupCustomers = BookingValue?.ServiceData?.map((item) => {
        const isTargetService =
          item?.serviceVariationId === serviceVariationId &&
          item?.PlaceValue === PlaceValue;

        if (isTargetService) {
          return {
            ...item,
            Teamname: fullName,
            TeamId: id,
            Comission: commissionData?.staffCommision ?? item.Comission,
            homeServicePrice:
              commissionData?.homeServicePrice ?? item.homeServicePrice,
            teamimg: image,
          };
        }
        return item;
      });
    } else if (id === 0) {
      updatedGroupCustomers = BookingValue?.ServiceData?.map((item) => ({
        ...item,
        Teamname: "Any professional",
        TeamId: 0,
        Comission: "",
        homeServicePrice: item.homeServicePrice,
        teamimg: "",
      }));

      // Switch back to global mode
      setSelectPerService(true);
      setShowAnyProfessionAgain(true);
    } else {
      updatedGroupCustomers = BookingValue?.ServiceData?.map((item) => ({
        ...item,
        Teamname: fullName,
        TeamId: id,
        Comission: commissionData?.staffCommision ?? item.Comission,
        homeServicePrice:
          commissionData?.homeServicePrice ?? item.homeServicePrice,
        teamimg: image,
      }));
    }

    const updatedBookingValue = {
      ...BookingValue,
      ServiceData: updatedGroupCustomers,
    };

    dispatch(setBookingValue(updatedBookingValue));

    const serviceIDs = updatedGroupCustomers.map((s) => s.ID);
    localStorage.setItem("serviceIDs", JSON.stringify(serviceIDs));

    setTeamData(NonTeamData);

    setShowModal(false);
    setbookingview(false);
  };

  const fetchappointmentdata = async () => {
    const CustomerData = await apiHandler({
      method: "GET",
      route: `Business/customerlist?businessId=${userData?.businessId}`,
    });

    console.log(CustomerData, "785454");
    const CustomerOption = [
      {
        label: "Walk in Customer",
        value: -1,
        email: "",
      },
      ...(CustomerData?.ResponseData?.map((el) => ({
        label: el.firstName,
        value: el.id,
        email: el?.email,
      })) || []),
    ];

    setcustomeroption(CustomerOption);

    const serviceData = await apiHandler({
      method: "GET",
      route: `Business/TeamserviceData?BusinessID=${userData.businessId}`,
    });
    console.log(serviceData, "785454");

    setservicedata(serviceData.ResponseData);

    const Team = await apiHandler({
      method: "GET",
      route: `Business/Teamdatabyfilterdayoff?businessId=${userData.businessId}&Todate=${Date}&Today=${today}&startTime=${startTime}&endTime=${endTime}`,
    });

    let teamdatas = [
      {
        fullName: "Any professional",
        id: 0,
        Comission: "0",
      },
      // {
      //   fullName: "select Procession service wise",
      //   id: 0,
      //   Comission: "0",
      // },
      ...(Team?.ResponseData || []),
    ];

    let teamvalue = teamdatas;
    if (BookingValue.ServiceData?.length > 0) {
      for (let i = 0; i < BookingValue.ServiceData.length; i++) {
        const teamId = BookingValue.ServiceData[i]?.TeamId;
        if (teamId && teamId !== 0) {
          teamvalue = teamvalue.filter((el) => el.id !== teamId);
        }
      }
    }

    setTeamData(teamvalue);

    // setTeamData(teamdatas);
    setnTeamData(teamdatas);

    const Teamservicecommissions = await apiHandler({
      method: "GET",
      route: `Business/Teamservicecommission?businessId=${userData.businessId}`,
    });

    setTeamservicecommission(Teamservicecommissions.ResponseData);
  };

  function totalCalculate() {
    const totalPrice = BookingValue?.ServiceData.reduce(
      (acc, item) =>
        acc +
        Number(item.servicePrice) +
        Number(item.Comission) +
        Number(item.homeServicePrice),
      0
    );

    return totalPrice;
  }

  const HandleBookNow = async () => {
    setLoading(true);
    setTab1(false);
    setTab2(false);
    setTab3(false);
    setTab4(false);
    setIsOpen1(false);
    setIsOpen2(false);
    setIsOpen(false);
    if (BookingValue?.SelectedCustomer == -1) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Add Customer before Book Appoinetment",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: "Business/appointmentUpsert",
      payload: {
        ID: BookingValue?.ID,
        startTime: startTime,
        endTime: endTime,
        Date: Date,
        today: today,
        BookingValue: JSON.stringify(BookingValue),
        IsGroup: BookingValue?.GroupCustomer == true ? 1 : 0,
        customerID: BookingValue?.SelectedCustomer,
        userId: userData?.id,
        businessId: userData?.businessId,
        homeService: serviceFilter ? 1 : 0,
        total: totalCalculate(),
      },
    });

    console.log(response, "456321data");
    if (response?.ResponseCode == "SUCCESS") {
      setLoading(false);
      let BookingValues = {
        SelectedCustomer: -1,
        ID: 0,
        formvalue: {
          FirstName: "",
          LastName: "",
          MobileNumber: "",
          Email: "",
          Date: "",
          ID: 0,
          Gender: 1,
        },
        GroupCustomers: [
          {
            label: "Walk in Customer",
            value: -1,
            email: "",
            checked: true,
            PlaceValue: 1,
          },
        ],

        ServiceData: [],
        IndiviualCustomer: true,
        GroupCustomer: false,
      };
      dispatch(setBookingValue(BookingValues));
      handleCancel();
      setLoading(false);
    } else {
      setLoading(false);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: response?.ResponseMessage,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const Handletimeslot = async () => {
    let teamIdbystring = BookingValue?.ServiceData.map((el) => el.TeamId).join(
      ","
    );

    const CustomerData = await apiHandler({
      method: "GET",
      route: `Business/gettimeslotbydate?Date=${Date}&today=${today}&businessId=${userData?.businessId}&TeamData=${teamIdbystring}`,
    });

    setstartTime(startTime);
    setendTime(endTime);
    settoday(moment(Date).format("dddd"));
    settimes(CustomerData?.ResponseData?.Dataarray);
  };

  const getGenderAll = async () => {
    const subResponse = await apiHandler({
      method: "GET",
      route: `Superadmin/genderAll`,
    });

    if (subResponse.ResponseCode === "SUCCESS") {
      const optionmanage = subResponse.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setGenderOptions(optionmanage);
    }
  };

  useEffect(() => {
    getGenderAll();
  }, []);

  // const Handlesettimes = (startTime, endTime) => {
  //   setstartTime(startTime);
  //   setendTime(endTime);
  //   setmonthlayout(false);
  // };

  const parseTimeToMinutes = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const formatMinutesToTime = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
  };

  const parseDurationToMinutes = (durationStr) => {
    if (typeof durationStr === "number") return durationStr;

    const lower = durationStr?.toLowerCase();

    const hourMatch = lower?.match(/(\d+(?:\.\d+)?)\s*(hour|h)/);
    const minMatch = lower?.match(/(\d+)\s*(min|m)/);

    let total = 0;

    if (hourMatch) {
      total += parseFloat(hourMatch[1]) * 60;
    }

    if (minMatch) {
      total += parseInt(minMatch[1], 10);
    }

    if (!hourMatch && !minMatch) {
      const direct = parseInt(durationStr, 10);
      if (!isNaN(direct)) total += direct;
    }

    return total;
  };

  console.log(BookingValue, "check this BookingValue 798");

  const getTotalServiceDuration = () => {
    return (BookingValue?.ServiceData ?? []).reduce((sum, s) => {
      const dur = parseDurationToMinutes(s.serviceDuration);
      return sum + (isNaN(dur) ? 0 : dur);
    }, 0);
  };

  const Handlesettimes = (newStartTime, Teamid) => {
    console.log(Teamid, "TeamidTeamidTeamid", BookingValue?.ServiceData.length);
    let maxlength = Math.max(...times.map((el) => el.Teamid.length));

    let result = times.filter((el) => el.Teamid.length == maxlength);

    let array = new Map();

    for (let key of BookingValue.ServiceData) {
      array.set(key.TeamId);
    }

    if (array.size == Teamid.length) {
      const totalDuration = getTotalServiceDuration(); // in minutes
      const startMinutes = parseTimeToMinutes(newStartTime);
      console.log(totalDuration, "check this totalDuration 789");

      const endMinutes = startMinutes + totalDuration;

      console.log(totalDuration, "check this totalDuration 78878");

      const endFormatted = formatMinutesToTime(endMinutes);

      setstartTime(newStartTime);
      setendTime(endFormatted);
      setmonthlayout(false);
    } else {
      Swal.fire({
        icon: 'info',
        title: `<strong style="font-size:20px; margin-top:10px;">Team Availability</strong>`,
        html: `
    <div style="text-align:left; font-size:15px;">
      <p style="margin-bottom:10px;">
        Only <b style="color:#3085d6;">"${Teamid}"</b> is available for this time slot.
      </p>
      
      <div style="background:#f4f6f9; padding:10px; border-radius:8px;">
        ${result.map((el) => `
          <div style="
            display:flex;
            justify-content:space-between;
            padding:6px 0;
            border-bottom:1px solid #ddd;
          ">
            <span>🕒 ${el.startTime} - ${el.endTime}</span>
            <span style="color:green; font-weight:500;">Available</span>
          </div>
        `).join("")}
      </div>
    </div>
  `,
        showConfirmButton: true,
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
        showCloseButton: true,
        allowOutsideClick: false,
        allowEscapeKey: true,

        didOpen: () => {
          const icon = document.querySelector('.swal2-icon');

          if (icon) {
            icon.style.width = '30px';
            icon.style.height = '30px';
            icon.style.margin = '10px auto';

            const iconContent = icon.querySelector('.swal2-icon-content');

            if (iconContent) {
              iconContent.style.fontSize = '22px';
            }
          }
        }
      });
    }
  };

  const groupedServices = (BookingValue?.ServiceData ?? []).reduce(
    (acc, service) => {
      acc[service.customerlabel] = acc[service.customerlabel] || [];
      acc[service.customerlabel].push(service);
      return acc;
    },
    {}
  );

  const handlebookingview = () => {
    setbookingview(true);
    setmonthlayout(true);
    Handletimeslot();
  };

  useEffect(() => {
    if (resourceData?.id > 0) {
      (async () => {
        const Data = await apiHandler({
          method: "GET",
          route: `Business/appointmentgetbyId?appointmentId=${resourceData?.id}`,
        });

        console.log(Data, "554545");
        dispatch(setBookingValue(Data?.ResponseData));
        setmonthlayout(false);
      })();
    }

    if (resourceData?.id == 0) {
      let BookingValues = {
        SelectedCustomer: -1,
        ID: 0,
        formvalue: {
          FirstName: "",
          LastName: "",
          MobileNumber: "",
          Email: "",
          Date: "",
          ID: 0,
          Gender: 1,
        },
        GroupCustomers: [
          {
            label: "Walk in Customer",
            value: -1,
            email: "",
            checked: true,
            PlaceValue: 1,
          },
        ],

        ServiceData: [],
        IndiviualCustomer: true,
        GroupCustomer: false,
      };
      dispatch(setBookingValue(BookingValues));
      if (viewtype == "week" || viewtype == "day") {
        setmonthlayout(false);
      }
    }
  }, [resourceData]);

  useEffect(() => {
    fetchappointmentdata();
    if (showAnyProfessionAgain) {
      const allAreAnyProfessional = (BookingValue?.ServiceData ?? []).every(
        (service) => service.TeamId === 0
      );

      if (allAreAnyProfessional) {
        setSelectPerService(true);
      }
    }
  }, [Teamdataget]);

  useEffect(() => {
    if (showAnyProfessionAgain) {
      const allAreAnyProfessional = (BookingValue?.ServiceData ?? []).every(
        (service) => service.TeamId === 0
      );

      if (allAreAnyProfessional) {
        setSelectPerService(false); // reset global mode
      }
    }
  }, [BookingValue?.ServiceData, showAnyProfessionAgain]);

  const handlechangeselectprofessional = () => {
    setSelectPerService(true); // Ensure that the global selection is 'Select professional per service'
    setShowModal(false);
    setShowAnyProfessionAgain(true); // Ensures this state is updated globally
  };

  const fetchTimeslot = async (day) => {
    try {
      const teamIds =
        BookingValue?.ServiceData?.map((el) => el.TeamId).join(",") || "";

      const res = await axios.get(
        `${config.backendUrl
        }/Business/gettimeslotbydate?Date=${day}&today=${moment(day).format(
          "dddd"
        )}&businessId=${userData.businessId}&TeamData=${teamIds}`
      );

      const timeData = res?.data?.ResponseData?.Dataarray || [
        {
          startTime: moment().format("HH:mm"),
          endTime: moment().format("HH:mm"),
        },
      ];

      seAvilableTimes(timeData); // <-- set available slots here

      dispatch(
        setBookingValue({
          ...BookingValue,
          daydate: day,
          today: moment(day).format("dddd"),
        })
      );
    } catch (error) {
      console.error("Error fetching timeslot:", error);
    }
  };

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      {tab1 && (
        <>
          <div
            className={`${
              // <div className={`sidebar-container scrollable-div p-2 col-3  border-end col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 ${
              isOpen
                ? "sidebar-container scrollable-div p-2 col-3  border-end col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 open"
                : "sidebar-container scrollable-div border-end col-sm-6 col-12 p-2 closed"
              }`}
          >
            <div className="d-flex align-items-center justify-content-between">
              <h6> Customer </h6>
              <buuton
                className="btn btn-primary btn-md me-2"
                onClick={() => {
                  setTab1(false);
                  setTab2(true);
                }}
              >
                Next
              </buuton>
            </div>
            <hr />
            <div className="pb-2">
              <Select
                classNamePrefix="react-select"
                options={customeroption}
                name="SelectedCustomer"
                onChange={(e) => Handlechange(e)}
                value={customeroption?.find(
                  (s) => s.value == BookingValue?.SelectedCustomer
                )}
                placeholder="Choose"
              />
            </div>
            <div className="d-flex gap-3 mt-2 mb-3">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  onChange={handleCheckboxChange}
                  name="IndiviualCustomer"
                  checked={BookingValue?.IndiviualCustomer}
                  style={{ height: "18px", width: "18px", marginRight: "6px" }}
                  className="custome-boder form-check-input"
                />
                <label className="mt-1 text-color-70">Individual Customer</label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  onChange={handleCheckboxChange}
                  name="GroupCustomer"
                  checked={BookingValue?.GroupCustomer}
                  style={{ height: "18px", width: "18px", marginRight: "6px" }}
                  className="custome-boder form-check-input"
                />
                <label className="mt-1 text-color-70">Group Customer</label>
              </div>
            </div>

            {BookingValue?.GroupCustomer == true ? (
              <div className="mb-3">
                <button
                  className="btn btn-primary btn-sm btn-wave ml-2 me-2"
                  onClick={() => HandleGuest()}
                >
                  {" "}
                  Add Guest{" "}
                </button>
              </div>
            ) : (
              <> </>
            )}

            <div className="row">
              {BookingValue?.GroupCustomers.map((el, index) => (
                <div key={index} className="col-xl-12">
                  <div className="card">
                    <div className="card-body p-2">
                      <div className="d-flex align-items-center w-100">
                        <div className="me-2">
                          <span className="avatar avatar-rounded">
                            <ImageWithBasePath
                              src="assets/img/avatar/avatar-2.jpg"
                              alt="img"
                            />
                          </span>
                        </div>
                        <div className="">
                          <div className="fs-15 fw-semibold">
                            <h6 className="fs-medium text-truncate mb-1">
                              {el.label}
                            </h6>
                          </div>
                          {/* <h6 className="fs-medium text-truncate mb-1"> */}
                          <p className="mb-0 text-fixed-black op-7 fs-12">
                            {el.email}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between ms-auto">
                          {el.value == BookingValue?.SelectedCustomer ? (
                            <> </>
                          ) : (
                            <div className="">
                              <button
                                className="btn btn-outline-primary custom-padding-sm-btn btn-sm me-2 mb-2"
                                onClick={() => handleclear(index, el.label)}
                              >
                                Remove
                              </button>
                            </div>
                          )}
                          <div className="">
                            <p className="text-fixed-black">
                              {/* <input
                          type="checkbox"
                          onChange={(e) => Handlegroupcheck(e, index)}
                          name={`Guest ${index + 1}`}
                          checked={el?.checked}
                        /> */}
                              {!el?.checked ? (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm btn-wave custom-padding-sm-btn me-2 mb-2"
                                  onClick={() => {
                                    const fakeEvent = {
                                      target: { checked: true },
                                    };
                                    Handlegroupcheck(fakeEvent, index);
                                  }}
                                >
                                  {/* Customer {index + 1} */}
                                  Select
                                </button>
                              ) : (
                                <input
                                  type="checkbox"
                                  onChange={(e) => Handlegroupcheck(e, index)}
                                  name={`Guest ${index + 1}`}
                                  style={{
                                    marginLeft: "10px",
                                    height: "26px",
                                    width: "26px",
                                    border: "none",
                                    marginTop: "8px",
                                  }}
                                  checked={el?.checked}
                                  className="form-check-input"
                                />
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <h6> Customer Details </h6>
            <hr />

            <form>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="d-flex align-items-center">
                    <h6>First Name</h6>{" "}
                    <span style={{ colou: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    className="form-control text-color-70"
                    onChange={handleFormValue}
                    value={BookingValue?.formvalue?.FirstName}
                    name="FirstName"
                    placeholder="First Name"
                  />
                </div>
                <div className="col-md-6">
                  <label>
                    <h6>Last Name</h6>
                  </label>
                  <input
                    type="text"
                    className="form-control text-color-70"
                    onChange={handleFormValue}
                    value={BookingValue?.formvalue?.LastName}
                    name="LastName"
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label>
                    <h6>Mobile Number</h6>
                  </label>
                  <input
                    type="tel" // Changed to 'tel' to allow special characters like + and spaces
                    name="MobileNumber"
                    className="form-control text-color-70"
                    value={
                      formatDBPhoneNumber(BookingValue?.formvalue?.MobileNumber) || ""
                    }
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\D/g, ""); // Strip non-digits
                      let formattedRaw = raw;

                      // Apply formatting logic to ensure proper phone number format
                      if (formattedRaw.startsWith("0")) {
                        formattedRaw = "61" + formattedRaw.slice(1); // Change leading 0 to +61
                      }

                      if (!formattedRaw.startsWith("61")) {
                        formattedRaw = "61" + formattedRaw; // Ensure prefix is +61
                      }

                      // Limit to 11 digits (e.g., +61 4X XXX XXX)
                      formattedRaw = formattedRaw.slice(0, 11);

                      // Update state with raw phone number for internal processing
                      dispatch(
                        setBookingValue({
                          ...BookingValue,
                          formvalue: { ...BookingValue?.formvalue, MobileNumber: formattedRaw },
                        })
                      );
                    }}
                    placeholder="Mobile Number"
                    onBlur={() => {
                      if (
                        BookingValue?.formvalue?.MobileNumber &&
                        !isValidAustralianPhoneNumbercust(
                          BookingValue?.formvalue?.MobileNumber
                        )
                      ) {
                        dispatch(
                          setBookingValue({
                            ...BookingValue,
                            phoneNumberError:
                              "Please enter a valid Australian Phone Number (e.g., +61 4XX XXX XXX or +61 2 XXXX XXXX).",
                          })
                        );
                      } else {
                        dispatch(
                          setBookingValue({
                            ...BookingValue,
                            phoneNumberError: "",
                          })
                        );
                      }
                    }}
                  />

                </div>
                <div className="col-md-6">
                  <label className="d-flex align-items-center">
                    <h6> Email</h6> <span style={{ colou: "red" }}> * </span>
                  </label>
                  <input
                    type="email"
                    name="Email"
                    onChange={handleFormValue}
                    value={BookingValue?.formvalue?.Email}
                    className="form-control text-color-70"
                    placeholder="Enter Your Email"
                  />
                </div>
                {BookingValue?.phoneNumberError && (
                  <span style={{ fontSize: "12px" }} className="text-danger">{BookingValue?.phoneNumberError}</span>
                )}
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label>
                    <h6>Date of Birth</h6>
                  </label>
                  <DatePickup
                    filterDate={BookingValue?.formvalue?.Date}
                    // showDefaultDate={true}
                    handleDateChange={(date) => handleInputChange(date)}
                  />
                </div>

                <div className="col-md-6">
                  <label>
                    <h6>Gender</h6>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    placeholder="Select Gender"
                    options={genderOptions}
                    value={genderOptions?.find(
                      (el) => el.value == BookingValue?.formvalue?.Gender
                    )}
                    onChange={(e) =>
                      handleFormValue({
                        target: { name: "Gender", value: e.value },
                      })
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <button
                    type="button"
                    onClick={() => handlesubmitdata()}
                    className="btn btn-outline-primary w-100"
                  // style={{ height: "40px" }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      )}

      {tab2 && (
        <>
          <div
            className={`${
              // <div className={`sidebar-container scrollable-div p-2 col-3  border-end col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 ${
              isOpen1
                ? "sidebar-container scrollable-div p-2 col-3  border-end col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 open"
                : "sidebar-container scrollable-div border-end col-sm-6 col-12 p-2 closed"
              }`}
          >
            <div className="d-flex align-items-center justify-content-between">
              <button
                className="btn btn-outline-primary btn-md me-2"
                onClick={() => {
                  setTab1(true);
                  setTab2(false);
                }}
              >
                Prev
              </button>
              <button
                className="btn btn-primary btn-md me-2"
                onClick={() => {
                  setTab3(true);
                  setTab2(false);
                }}
              >
                Next
              </button>
            </div>
            <div className="d-flex align-items-center gap-3">
              <h6 className="mt-1"> Services </h6>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={serviceFilter}
                  onChange={(e) => setServiceFilter(e.target.checked)}
                />
                <label className="d-flex align-items-center mt-1">
                  <h6>Home Service</h6>
                </label>
              </div>
            </div>

            <hr />

            <div className="row">
              {serviceData
                ?.filter((el) =>
                  serviceFilter
                    ? el.isThisHomeService === 1
                    : el.isThisHomeService === 0
                )
                .map((el, index) => {
                  const customer = BookingValue?.GroupCustomers?.find(
                    (item) => item.checked
                  );
                  const isSelected = BookingValue?.ServiceData?.some(
                    (s) =>
                      s.serviceVariationId === el.PriceID &&
                      s.customerlabel === customer?.label
                  );

                  return (
                    <div
                      key={index}
                      className="col-xl-12"
                      onClick={() => Handleservices(el)}
                    >
                      <div className="card">
                        <div
                          style={{ cursor: "pointer" }}
                          className={`card-body p-2 ${isSelected ? "boo-custome-survice-active" : ""
                            }`}
                        >
                          <div className="d-flex align-items-center w-100">
                            <div className="me-2">
                              <span className="avatar avatar-rounded">
                                <ImageWithBasePath
                                  src={config?.Imageurl + el.imageUrl}
                                  alt="img"
                                />
                              </span>
                            </div>
                            <div className="w-100">
                              <div className="fs-15 fw-semibold">
                                <h6 className="fs-medium text-truncate mb-1">
                                  {el.name}
                                </h6>
                              </div>
                              <div className="d-flex justify-content-between w-100 fs-15 fw-semibold">
                                <p className="salman mb-0 text-color-70 fs-12">
                                  {el.category} | {el.duration} |{" "}
                                  {el.isThisHomeService == 1
                                    ? "Home Service"
                                    : "In Store"}
                                  {el.isThisComboService == 1 &&
                                    " | Combo Service"}
                                </p>
                                <div className="ms-auto">
                                  <div className="fw-bold custome-font">
                                    {`$${Number(el.price).toFixed(2)}`}
                                  </div>
                                </div>
                              </div>
                              {el.isThisComboService == 1 && (
                                <div>
                                  {el.comboServiceIds
                                    ?.split(",")
                                    .map((comboId) => {
                                      const comboService = serviceData.find(
                                        (service) =>
                                          service.serviceId ===
                                          parseInt(comboId)
                                      );
                                      return comboService ? (
                                        <p key={comboId} className="mb-0">
                                          {comboService.name} - Price:{" "}
                                          {comboService.price}
                                        </p>
                                      ) : null;
                                    })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}

      {tab3 && (
        <>
          <div
            className={`${isOpen2
              ? "sidebar-container scrollable-div p-2 border-end col-12 open-2"
              : "sidebar-container scrollable-div border-end col-12 p-2 closed"
              }`}
          >
            <div className="d-flex justify-content-between align-items-center mb-3 px-3">
              <button
                className="btn btn-outline-primary btn-md me-2"
                onClick={() => {
                  setTab2(true);
                  setTab3(false);
                }}
              >
                Prev
              </button>
              <button
                className="btn btn-primary btn-md"
                onClick={() => {
                  handlebookingview();
                  fetchTimeslot(Date);
                  setTab3(false);
                  setTab4(true);
                }}
              >
                Next
              </button>
            </div>

            <h6 className="fw-bold">Staff</h6>
            <hr />

            {[
              ...new Set(
                BookingValue?.ServiceData?.map((item) => item.customerlabel)
              ),
            ]?.map((el, index) => (
              <div key={index}>
                <h6>{el}</h6>
                <div className="row">
                  {BookingValue?.ServiceData?.filter(
                    (service) => service.customerlabel === el
                  ).map((item, idx) => (
                    <div key={idx} className="col-12 mt-2">
                      <div className="card p-2">
                        <div className="card-body p-0">
                          <div className="d-flex">
                            {/* Image */}
                            <div className="me-3 flex-shrink-0">
                              <img
                                src={config?.Imageurl + item.imageUrl}
                                alt={item.serviceName}
                                className="service-image"
                                onError={(e) => {
                                  e.currentTarget.src =
                                    "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                }}
                              />
                            </div>

                            {/* Content */}
                            <div className="flex-grow-1 overflow-hidden">
                              <div className="d-flex flex-column">
                                <h6
                                  title={`${item.serviceName} - ${item.menucategory}`}
                                  className="fs-medium mb-1 text-truncate one-line-content-custom"
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {item.serviceName} - {item.menucategory}
                                </h6>
                                {Number(item?.Comission ?? 0) > 0 && (
                                  <p className="m-0">
                                    Staff Charges:{" "}
                                    {Number(item?.Comission ?? 0).toFixed(2)}
                                  </p>
                                )}
                                {Number(item?.homeServicePrice ?? 0) > 0 && (
                                  <p className="m-0">
                                    Home Service Charges:{" "}
                                    {Number(
                                      item?.homeServicePrice ?? 0
                                    ).toFixed(2)}
                                  </p>
                                )}
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <div className="d-flex">
                                  <button
                                    onClick={() => handleAddTeam(item)}
                                    className="btn btn-outline-primary btn-sm custom-padding-sm-btn me-2 fw-bold"
                                  >
                                    <div className="d-flex align-items-center">
                                      <img
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                          borderRadius: "50%",
                                          marginRight: "8px",
                                          objectFit: "cover",
                                        }}
                                        src={config?.Imageurl + item.teamimg}
                                        onError={(e) => {
                                          e.currentTarget.src =
                                            "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                        }}
                                      />
                                      {item?.Teamname}
                                    </div>
                                  </button>
                                  <button
                                    onClick={() => Handleremoveservices(item)}
                                    className="btn btn-primary btn-sm custom-padding-sm-btn me-2"
                                  >
                                    Remove
                                  </button>
                                </div>
                                <div className="fw-bold">
                                  $
                                  {(
                                    Number(item?.servicePrice ?? 0) +
                                    Number(item?.Comission ?? 0) +
                                    Number(item?.homeServicePrice ?? 0)
                                  ).toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {tab4 && (
        <>
          {bookingview ? (
            <div
              className={`${isOpen
                ? "sidebar-container scrollable-div p-2 border-end col-12 open-2"
                : "scrollable-div p-2 col-4  border-end col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                }`}
            >
              <div className="d-flex justify-content-between align-items-center mb-3 px-3">
                <button
                  className="btn btn-outline-primary btn-md me-2"
                  onClick={() => {
                    setTab3(true);
                    setTab4(false);
                  }}
                >
                  Prev
                </button>
              </div>
              <h6> Booking Form </h6>
              <hr />

              {monthlayout ? (
                <>
                  <div className="container-slider">
                    <div className="d-flex justify-content-center align-items-center my-3">
                      <div className="swiper-container swiper-group-animate swiper-group-journey">
                        <div className="container d-flex gap-3">
                          <Swiper
                            {...swiperGroupAnimate}
                            // spaceBetween={10}
                            slidesPerView={30}
                            // navigation={true}
                            // loop={true}
                            style={{ width: "400px" }}
                          >
                            {dates.map((item, index) => (
                              <SwiperSlide
                                key={index}
                                className="boo-custom-slide text-center"
                              >
                                <div
                                  className={
                                    item?.daydate == Date
                                      ? "bg-active"
                                      : "bg-white"
                                  }
                                  style={{
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                    width: "60px",
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    border: "1px solid #ddd",
                                    boxShadow: "none",
                                    transition: "all 0.3s ease",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                  }}
                                  onClick={() => {
                                    fetchTimeslot(item?.daydate);
                                    if (item?.isDayOff != 1) {
                                      setDate(item?.daydate);
                                    }
                                  }}
                                >
                                  <span
                                    className={
                                      item?.isDayOff == 1
                                        ? "boo-strikethrough"
                                        : ""
                                    }
                                    style={{
                                      color:
                                        item?.isDayOff == 1
                                          ? "rgb(135 120 120)"
                                          : "#000",
                                    }}
                                  >
                                    {item?.daydate?.split("-")[2]}
                                  </span>
                                </div>
                                {/* Day below the circle using UL/LI for exact positioning */}
                                <ul
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    listStyle: "none",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <li
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      color: "#666",
                                      marginRight: "10px",
                                    }}
                                  >
                                    {/* {item?.nickday} */}
                                  </li>
                                </ul>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      </div>
                    </div>

                    {/* Time Picker Section */}
                    <div className="d-flex flex-column">
                      {avilableTimes.length === 0 ? (
                        <p>No slots available</p>
                      ) : (
                        avilableTimes.map((slot, index) => (
                          <button
                            key={index}
                            type="button"
                            className="boo-time-button btn btn-outline-primary mb-2 d-flex align-items-center"
                            style={{
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                            onClick={() =>
                              Handlesettimes(slot.startTime, slot.TeamName)
                            }
                          >
                            {/* Slot time */}
                            <span>
                              {slot.startTime} - {slot.endTime}
                            </span>

                            {/* Team images */}
                            <span className="d-flex gap-2">
                              {slot.TeamName.map((name) => {
                                // Find the team member in TeamData
                                const member = TeamData.find(
                                  (t) => t.fullName === name
                                );
                                return member ? (
                                  <img
                                    key={member.id}
                                    src={config?.Imageurl + member.image}
                                    alt={member.fullName}
                                    title={member.fullName} // optional: show name on hover
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src =
                                        "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                    }}
                                  />
                                ) : null;
                              })}
                            </span>
                          </button>
                        ))
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="container">
                    <div className="row">

                      <div className="mb-1 col-12">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <h6 style={{ marginRight: "6px" }}>From :</h6>{" "}
                            <span className="text-color-70 fs-12">
                              {moment(Date).format("DD/MM/YYYY")}
                            </span>
                          </div>
                          <div className="ml-auto">
                            <button
                              onClick={() => setmonthlayout(true)}
                              className="btn btn-outline-primary btn-sm btn-wave"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3 col-12">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <h6 style={{ marginRight: "6px" }}>Time :</h6>{" "}
                            <span className="text-color-70 fs-12">
                              {startTime} to {endTime}
                            </span>
                          </div>
                          <div className="ml-auto">
                            <button
                              onClick={() => setmonthlayout(true)}
                              className="btn btn-outline-primary btn-sm btn-wave"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="mb-1 col-12">
                        <h6>Booking Slot</h6>
                      </div>
                      <div style={{ maxHeight: "500px", overflow: "scroll" }}>
                        {Object.entries(groupedServices).map(
                          ([customerLabel, services]) => (
                            <div key={customerLabel} className="d-flex row">
                              <strong
                                style={{ color: "black" }}
                                className="mb-4"
                              >
                                {customerLabel}
                              </strong>
                              {services.map((service, index) => (
                                <div
                                  key={index}
                                  className="col-12"
                                >
                                  <div className="row d-flex flex-wrap justify-content-between  wow fadeInUp mb-3">
                                    <div className="col-12 d-flex">
                                      <div className="card-info">
                                        <p className="text-md-bold neutral-1000">
                                          {service.serviceName}
                                        </p>
                                        <div className="card-meta">
                                          <p
                                            title={service.serviceDuration}
                                            className="text-md-medium neutral-500 tour-code mr-15"
                                          >
                                            {service.serviceDuration} - with{" "}
                                            {service?.Teamname}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex col-12">
                                      <div className="col-6 "></div>

                                      <div className="col-md-5 d-flex justify-content-between">
                                        <div>
                                          <p
                                            title={service.servicePrice}
                                            className="text-md-bold neutral-1000 tour-code mr-15"
                                          >
                                            {(
                                              Number(
                                                service?.servicePrice ?? 0
                                              ) +
                                              Number(
                                                service?.Comission ?? 0
                                              ) +
                                              Number(
                                                service?.homeServicePrice ?? 0
                                              )
                                            ).toFixed(2)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              ))}
                            </div>
                          )
                        )}
                      </div>

                    </div>
                  </div>
                </>
              )}

              <div className="row pt-3">
                <div className="col-md-10">
                  <h6>Total</h6>
                </div>
                <strong className="col-md-2 ms-auto">
                  {" "}
                  <h6> $ {totalCalculate()}</h6>
                </strong>
              </div>

              <div className="book-now-container">
                <div className="row mt-2">
                  <div className="col-md-12">
                    <button
                      onClick={() => { HandleBookNow() }}
                      className="btn btn-primary w-100 book-now-btn"
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <> </>
          )}
        </>
      )}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{serivesTeam?.serviceName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <>
              {!selectPerService && (
                <div className="col-md-3">
                  <div
                    className="card border border-secondary d-flex flex-column align-items-center p-2 gap-1 cursor-pointer"
                    onClick={handlechangeselectprofessional}
                    style={{ height: "100px", background: "#fff" }}
                  >
                    <img
                      style={{ height: "60px" }}
                      className="boo-profession-select-img"
                      src="https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png"
                      alt="Select per service"
                    />
                    <p className="fs-14 fw-semibold lh-1">
                      Select professional per service
                    </p>
                  </div>
                </div>
              )}
              {TeamData?.map((el) => {
                let commisiiondata = Teamservicecommission.find(
                  (tsc) =>
                    tsc?.staffId == el.id && tsc?.serviceId == serivesTeam?.ID
                );
                let commission = commisiiondata?.staffCommision || 0;
                let homeServicePrice = commisiiondata?.homeServicePrice || 0;
                return (
                  <div
                    key={el.id}
                    className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 "
                    onClick={() =>
                      handleaddteamtoservice(
                        serivesTeam?.serviceVariationId,
                        serivesTeam?.PlaceValue,
                        serivesTeam?.ID,
                        el.id,
                        el?.fullName,
                        el?.image
                      )
                    }
                  >
                    <div className="card border border-primary">
                      <div className="text-center pt-1">
                        <div className="avatar-list-stacked">
                          <span className="avatar avatar-lg avatar-rounded">
                            <ImageWithBasePath
                              src={config?.Imageurl + el.image}
                              alt="img"
                            />
                          </span>
                        </div>
                        <p className="fs-14 fw-semibold mb-2 mt-2 lh-1">
                          {el?.fullName}
                        </p>
                        <p className="fs-10 custome-muted-font mb-2 lh-1">
                          {el?.designation}
                        </p>
                        <p className="fs-10 custome-muted-font mb-2 lh-1">
                          staffPrice: {commission} | home Service Charges:{" "}
                          {homeServicePrice}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddStaffappointment;
